var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIdeas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.53,
    height: 21.52,
    viewBox: "0 0 20.53 21.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-ideas"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.83,6.19a4.07,4.07,0,1,1-.7,8.1A3.88,3.88,0,0,1,6.53,10,4.1,4.1,0,0,1,10.83,6.19Zm0,.6A3.47,3.47,0,0,0,7.13,10a3.34,3.34,0,0,0,3.2,3.7,3.4,3.4,0,0,0,3.7-3.2A3.53,3.53,0,0,0,10.83,6.79Z",
    transform: "translate(-1.8 -1.48)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.9,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43,14.49l.9-.7a.28.28,0,1,1,.4.4l-.9.7a.3.3,0,0,1-.4,0c-.1-.1-.1-.1-.1-.2S5.33,14.49,5.43,14.49Z",
    transform: "translate(-1.8 -1.48)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_107",
    "data-name": "Capa 107"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.9,6.3c-.1-.1-.2-.2-.1-.3l.2-.6h-.3a.52.52,0,0,1-.4-.2.3.3,0,0,1,0-.4l.4-.6a.4.4,0,0,1,.4-.2c.1.1.2.2.1.3l-.3.5h.3a.52.52,0,0,1,.4.2.3.3,0,0,1,0,.4l-.4.6c0,.1-.1.1-.2.1Z",
    transform: "translate(-1.8 -1.48)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,8.3a.9.9,0,0,1-.5-.1.6.6,0,0,1-.1-.4V7.5A3.42,3.42,0,0,1,16,4.9a3,3,0,0,1,1.1-2.3A2.83,2.83,0,0,1,19.6,2a3.1,3.1,0,0,1,2,1.5,3.2,3.2,0,0,1-1.1,3.9v.3a.6.6,0,0,1-.1.4.76.76,0,0,1-.5.2Zm0-.5h2V7.3c0-.1,0-.2.1-.2a2.51,2.51,0,0,0,1-3.3,2.62,2.62,0,0,0-1.6-1.3,2.34,2.34,0,0,0-2.1.5,2.46,2.46,0,0,0-.9,1.9,2.79,2.79,0,0,0,1.3,2.2c.1,0,.1.1.1.2l.1.5Z",
    transform: "translate(-1.8 -1.48)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.9,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1,10.2a4.48,4.48,0,0,0-2.3,0c-.1,0-.3,0-.3-.2s0-.3.2-.3a5.28,5.28,0,0,1,2.5,0c.1,0,.2.2.2.3s-.1.2-.3.2Z",
    transform: "translate(-1.8 -1.48)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.9
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_110",
    "data-name": "Capa 110"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.7,23c-.4,0-.8-.1-1.2-.1a3.86,3.86,0,0,1-3.6-3.1,6.6,6.6,0,0,1-.1-1.4V7A11,11,0,0,1,2,5.2,3.93,3.93,0,0,1,5.5,2.6h8.1c.8,0,1.4.6,1.1,1.2-.1.4-.6.6-1.1.6H6A1.9,1.9,0,0,0,4,6.1V19a1.7,1.7,0,0,0,.1.7A1.79,1.79,0,0,0,6,21.1H16.1a7.57,7.57,0,0,0,1.5-.1,1.71,1.71,0,0,0,1.6-1.5c0-.4.1-.7.1-1.1V12.9a1.14,1.14,0,0,1,.3-.8,1.1,1.1,0,0,1,1.7.3c0,.1.1.1.1.2v6.5c0,.2-.1.5-.1.7a4,4,0,0,1-3.7,3.1c-.4,0-.8.1-1.2.1Z",
    transform: "translate(-1.8 -1.48)",
    fill: "{props.color}"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_135",
    "data-name": "Capa 135"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5,3.4H4.7C4,4.4,3.2,5.3,2.5,6.3l.2,13.4,2.2,2.4H18.5l1.8-2.3c-.1-2.5-.1-5-.2-7.5",
    transform: "translate(-1.8 -1.48)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("rect", {
    x: 12.7,
    y: 14.42,
    width: 1.1,
    height: 5.2,
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.2,
    y: 13.22,
    width: 1.1,
    height: 6.4,
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.9
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-1.8 -1.48)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIdeas);
export default __webpack_public_path__ + "static/media/search-ideas.4e51db5ca052fcfbfeaaab29d9680138.svg";
export { ForwardRef as ReactComponent };